import { NavigationGuard, Route } from 'vue-router';
import { useKeycloak } from '../composables/keycloak';
import { UserStatus } from '@/modules/organization/constants';
import Auth from '@/modules/auth/api/auth';

type Next = Parameters<NavigationGuard>[2];

export const HomeGuard = async (to: Route, from: Route, next: Next) => {
    const { createAndInitializeKeycloak, isAuthenticated, hasUserId, login } = useKeycloak();
    await createAndInitializeKeycloak(true);

    if (isAuthenticated()) {
        // newlly registered user does not exist in the db yet so we need execute a backend login
        if (!hasUserId()) {
            await login(to);
        } else {
            const { data } = await Auth.user();
            if (data.status === UserStatus.Pending && !data.organisationId) {
                next({ name: 'organization-registration' });
            } else if (data.status === UserStatus.Pending && data.organisationId) {
                next({ name: 'unverified-organization' });
            }
        }
    }

    return next();
};
